import { connect } from 'react-redux';
import Modal from './Modal';
import { closeModal } from '../../modules/modal/actions';
const mapState = (_) => ({});
const mapDispatch = (dispatch) => ({
    onCloseModal: (name) => dispatch(closeModal(name))
});
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});
export default connect(mapState, mapDispatch, mergeProps)(Modal);
//# sourceMappingURL=Modal.container.js.map